import React, { useState } from 'react';

import Slider from '@mui/material/Slider';

const SidebarDDSalary = ({ minSalary, maxSalary, setMinSalary, setMaxSalary }) => {
    const [isOpen, setIsOpen] = useState(true);

    const toggleDropdown = () => setIsOpen(!isOpen);

    const handleSliderChange = (event, newValue) => {
        setMinSalary(newValue[0]);
        setMaxSalary(newValue[1]);
    };

    return (
        <div className="w-full">
            {/* Toggle Button */}
            <div
                className="w-full flex justify-between items-center px-0 py-2 h-10 bg-white text-[#5A6474] font-medium cursor-pointer"
                onClick={toggleDropdown}
            >
                <span className="text-sm font-dmsans font-bold">Salary Range</span>
                <svg
                    className={`w-4 h-4 transform transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`}
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    viewBox="0 0 24 24"
                >
                    <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
                </svg>
            </div>

            {/* Dropdown Content */}
            {isOpen && (
                <div className="w-full px-0 py-2 bg-white rounded-b-md">
                    <div className="flex justify-between mb-2 text-sm text-[#5A6474]">
                        <span>${minSalary.toLocaleString()}</span>
                        <span>${maxSalary.toLocaleString()}</span>
                    </div>

                    <div className='px-2'>
                        <Slider
                            getAriaLabel={() => 'Salary range'}
                            value={[minSalary, maxSalary]}
                            onChange={handleSliderChange}
                            min={0}
                            // Align this with your actual maximum possible salary
                            max={1000000} // <-- FIX: Changed from 200000 to 1000000
                            step={10000}
                            valueLabelDisplay="auto"
                            disableSwap
                        />
                    </div>
                </div>
            )}
        </div>
    );
};

export default SidebarDDSalary;
